import React, { useState, useEffect } from "react";
import { Grid, Typography } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { useSelector } from "react-redux";
import TabWidget from "app/components/molecules/tab/TabWidget.mui";
import { globalTheme } from "style/globalTheme";
import { useStyles } from "./style";
import ListWidget from "app/components/mvp/listWidget";
import { config } from "utilities/config";
import { post } from "app/services/api";
import {
  getContactTopicsListPayload,
  GetTopicsListPayload,
  AddTopicPayload,
  DeleteTopicPayload,
} from "./model/topicsPayload";
import { getTopicsListSchema } from "./model/topicsSchema";
import { getTopicsListUiSchema } from "./model/topicsUiSchema";

function ManageTopics(props) {
  const classes = useStyles();
  const getcontactId = useSelector((state) => state.contactid);
  const [topicsList, setTopicsList] = useState({});

  useEffect(() => {
    getTopicsList();
  }, [getcontactId]);

  const getTopicsList = () => {
    let api;
    let formData = {};
    api = config.teleportal.submitForm.get;
    const payloads = GetTopicsListPayload;

    post(api, payloads)
      .then((res) => {
        res.data.data.forEach((obj) => {
          formData[obj.data[0].value] = {
            name: obj.data[1].value,
            description: obj.data[2].value,
            category: obj.data[3]?.value || "",
          };
        });
        setTopicsList(formData);
      })
      .catch(console.log);
  };

  // Columns for Tab 1 (Topics)
  const tab1Columns = [
    {
      field: "ctpt_topicsid",
      flex: 1,
      headerName: "Topic Name",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <p style={{ marginLeft: "1rem" }}>
          {topicsList[params.value]?.name || ""}
        </p>
      ),
    },
    {
      field: "ctpt_topicsid",
      flex: 1.5,
      headerName: "Description",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <p style={{ marginLeft: "1rem" }}>
          {topicsList[params.value]?.description || ""}
        </p>
      ),
    },
    {
      field: "ctpt_topicsid",
      flex: 1,
      headerName: "Category",
      headerClassName: "super-app-theme--header",
      renderCell: (params) => (
        <p style={{ marginLeft: "1rem" }}>
          {topicsList[params.value]?.category || ""}
        </p>
      ),
    },
  ];

  // Columns for Tab 2 (Subjects - keeping static for now, can be updated later)
  const tab2Columns = [
    {
      field: "name",
      flex: 1,
      headerName: "Subject Name",
      headerClassName: "super-app-theme--header",
    },
    {
      field: "description",
      flex: 1.5,
      headerName: "Description",
      headerClassName: "super-app-theme--header",
    },
    {
      field: "category",
      flex: 1,
      headerName: "Type",
      headerClassName: "super-app-theme--header",
    },
    {
      field: "status",
      flex: 0.8,
      headerName: "Status",
      headerClassName: "super-app-theme--header",
    },
  ];

  // Configuration for Tab 1 Grid (Topics)
  const tab1Configuration = {
    apiURL: config.teleportal.submitForm.get,
    apiUrlDel: config.teleportal.submitForm.Update,
    columns: tab1Columns,
    searchPayload: "searchFilter",
    getlistPayload: getContactTopicsListPayload(getcontactId),
    deleteListPayload: DeleteTopicPayload,
    formwidgetOptions: {
      widgetType: "update",
      formSchema: getTopicsListSchema,
      uiSchema: getTopicsListUiSchema,
      apiURL: config.teleportal.submitForm.Update,
      entityType: "ctpt_topics",
      formUischema: "",
      button1Label: "Add",
      button2Label: "Cancel",
      button3Label: "Clear",
      payloadSubmit: AddTopicPayload,
      columns: tab1Columns,
      contactId: getcontactId,
      historyUrl: "",
    },
    listHeading: "My Topics",
    nonRecord: false,
    rows: "",
    localDataStore: true,
    contactId: getcontactId,
    hideSearch: true,
    pageSize: 10,
    hasPayloadfilter: true,
    hideModalOnSubmit: true,
    hideDelete: false,
    hideAdd: false,
    hasAggregate: false,
    staticTable: false,
    staticRow: [],
    formatStaticRow: false,
    hiddenColumn: {},
    filteredValue: "",
    hasFilter: false,
    filterField: "",
    filterValue: [],
    aggregateColumns: [],
    aggregateField: "",
    getRowId: (row) => row.ctpt_topicsid,
  };

  // Configuration for Tab 2 Grid (Subjects - keeping static for now)
  const tab2SampleData = [
    { id: 1, name: "Subject X", description: "Description for Subject X", category: "Type A", status: "Active" },
    { id: 2, name: "Subject Y", description: "Description for Subject Y", category: "Type B", status: "Active" },
  ];

  const tab2Configuration = {
    apiURL: "",
    apiUrlDel: "",
    columns: tab2Columns,
    searchPayload: "searchFilter",
    getlistPayload: {},
    deleteListPayload: {},
    listHeading: "",
    nonRecord: false,
    role: "",
    rows: "",
    localDataStore: false,
    hideControls: true,
    hideAdd: true,
    hasAggregate: false,
    staticTable: true,
    staticRow: tab2SampleData,
    formatStaticRow: false,
    hiddenColumn: {},
    contactId: "",
    filteredValue: "",
    hasFilter: false,
    filterField: "",
    filterValue: [],
    aggregateColumns: [],
    aggregateField: "",
    hasPayloadfilter: false,
    hideDelete: true,
    hideSearch: false,
    enableLocalSearch: true,
    pageSize: 10,
    getRowId: (row) => row.id,
  };

  return (
    <ThemeProvider theme={globalTheme}>
      <AuthenticatedTemplate>
        <div className={classes.container}>
          <Typography
            variant="h4"
            component="h1"
            style={{
              textAlign: "center",
              marginBottom: "2rem",
              fontWeight: "bold",
            }}
          >
            Manage Topics
          </Typography>
          <TabWidget
            options={{
              defaultTabID: 1,
              tabNavJson: [
                {
                  label: "Topics",
                  id: 1,
                  entity: (
                    <Grid container spacing={0} justify="center">
                      <Grid item xs={12} md={10} className={classes.gridContainer}>
                        <ListWidget options={tab1Configuration} topicsList={topicsList} />
                      </Grid>
                    </Grid>
                  ),
                },
                {
                  label: "Subjects",
                  id: 2,
                  entity: (
                    <Grid container spacing={0} justify="center">
                      <Grid item xs={12} md={10} className={classes.gridContainer}>
                        <ListWidget options={tab2Configuration} />
                      </Grid>
                    </Grid>
                  ),
                },
              ],
            }}
          />
        </div>
      </AuthenticatedTemplate>
    </ThemeProvider>
  );
}

export default ManageTopics;

